import { render } from "./BallotCard.vue?vue&type=template&id=e50e59fa"
import script from "./BallotCard.vue?vue&type=script&lang=js"
export * from "./BallotCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__